<template>
  <div>
    <van-popup
      class="popups"
      v-model="showDrz"
      position="bottom"
      round
      :style="{ height: '500px' }"
    >
      <div class="identity_choice">
        <div class="identity_choice_title">
          <div class="closePopups" @click="closePopup">关闭</div>
          <div class="popupTitle">
            为提高贷款成功率，请选择以下任一身份完成认证或新增贷款身份
          </div>
        </div>
        <div class="spans">
          <div
            style="margin-bottom: 20px; font-size: 14px; color: #252525"
            v-if="this.personalList && this.personalList.length > '0'"
          >
            个人身份
            <div v-for="(item, index) in personalList" :key="index">
              <div class="qy_list" @click="chooseEnterprise(item, '1')">
                <div>
                  <p style="margin-right: 5px">{{ item.name }}</p>
                  <p class="p_creditNo">{{ creditNoDrz }}</p>
                </div>
                <span class="pending_txt" v-if="item.status != '3'"
                  >待完成认证</span
                >
              </div>
            </div>
          </div>
          <div class="enterprise_list" v-if="this.enterpriseList.length > '0'">
            企业身份
            <div v-for="(item, index) in enterpriseList" :key="index">
              <div class="qy_list" @click="chooseEnterprise(item, '2')">
                <div>
                  <p>{{ item.cusName }}</p>
                  <p class="p_creditNo">{{ item.creditNo }}</p>
                </div>
                <span class="pending_txt" v-if="item.status != '3'"
                  >待完成认证</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btns">
        <van-button
          class="newBtn"
          @click="newIdentity"
          type="info"
          size="large"
          round
          >新增贷款身份</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "enterpriseList",
  props: ["enterpriseList", "personalList"],
  data() {
    return {
      showDrz: false,
    };
  },

  computed: {
    creditNoDrz() {
      if (this.personalList.length > 0) {
        let card = this.personalList[0].creditNo;
        let strcard = card.replace(/^(.{4})(?:\d+)(.{4})$/, "$1******$2");
        return strcard;
      }
    },
  },

  methods: {
    // 关闭弹窗
    closePopup() {
      this.$emit("closePopup");
    },

    // 选择身份认证
    chooseEnterprise(item, type) {
      this.$emit("chooseEnterprise", item, type);
    },

    // 新增身份
    newIdentity() {
      this.$emit("newIdentity");
    },
  },
};
</script>

<style lang="less" scoped>
.popups {
  // position: relative;
  .identity_choice {
    // height: 155px;
    // margin-top: 40px;
    padding: 0 17px;
    font-size: 15px;
    margin-bottom: 30px;
    height: 100%;
    p {
      color: #acacac;
    }
    .identity_choice_title {
      background-color: #fff;
      font-weight: 500;
      color: #303030;
      font-size: 17px;
      position: sticky;
      top: 0;
      z-index: 999;
      .closePopups {
        width: 100%;
        padding-top: 13px;
        color: #252525;
        text-align: right;
        font-size: 14px;
      }
      .popupTitle {
        color: #303030;
        font-size: 14px;
        line-height: 24px;
        margin-top: 17px;
        font-weight: 400;
        padding-right: 13px;
      }
    }
    .spans {
      //   height: 100%;
      overflow: scroll;
      margin-top: 30px;
      padding-bottom: 70px;
      .enterprise_list {
        color: #252525;
        font-size: 14px;
        margin-bottom: 15px;
        font-weight: 400;
      }
      .gr_list {
        border: 1px solid #e8edf1;
        border-radius: 4px;
        padding: 12px 15px;
        background: linear-gradient(180deg, #f3f8ff 0%, #ffffff 100%);
        color: #303030;
        font-size: 18px;
        font-weight: bold;
        margin-top: 12px;
        border-bottom: 1px solid #eee;
        padding-bottom: 8px;
        margin-top: 12px;
        display: flex;
        justify-content: space-between;
        .pending_txt {
          font-family: PingFangSC-Regular, PingFang SC;
          font-size: 14px;
          color: #ff0000;
          font-weight: bold;
        }
      }
      .qy_list {
        border: 1px solid #e8edf1;
        border-radius: 4px;
        padding: 12px 15px;
        background: linear-gradient(180deg, #f3f8ff 0%, #ffffff 100%);
        margin-top: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
          color: #252525;
          font-size: 16px;
          font-weight: bold;
        }
        .p_creditNo {
          font-size: 12px;
          color: #646b86;
        }
        .pending_txt {
          font-family: PingFangSC-Regular, PingFang SC;
          font-size: 12px;
          color: #2660ce;
          font-weight: bold;
        }
      }
    }
  }
  .btns {
    position: fixed;
    width: 100%;
    padding: 0 15px;
    bottom: 10px;
    height: 90px;
    line-height: 100px;
    background-color: #fff;
    .newBtn {
      color: rgba(255, 255, 255, 1);
      height: 43px;
      line-height: 43px;
      font-weight: 600;
      font-size: 15px;
      background-color: #2560ce;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/modules/identityAuthentication/enterpriseList.vue